/**
 * @enum TableActionMode
 * @description Display mode for table actions
 */
export enum TableActionMode {
  /**
   * Actions displayed as inline buttons (default)
   */
  Inline = 'inline',

  /**
   * Actions displayed in dropdown menu
   */
  Menu = 'menu'
}

/**
 * @description Union type for table action mode that accepts both enum values and string literals
 */
export type TableActionModeUnion = 'inline' | 'menu';

/**
 * @description Union type for table action mode
 */
export type ITableActionMode = TableActionMode | TableActionModeUnion;
